import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { message, Tabs, Row, Col, Tag, Table, Select, Form, Spin, Button, Alert } from 'antd';
import CuotaOrdinariaFormularioModal from '../../../components/PagosPendientes/CuotasOrdinaria/CuotaOrdinariaFormularioModal';
import CuotaFondoFormularioModal from '../../../components/PagosPendientes/CuotasFondo/CuotaFondoFormularioModal';
import FraccionarFormularioModal from '../../../components/Fraccionar/FraccionarFormularioModal';
import ColegiadoService from '../../../services/api/colegiados';
import HistorialEnvioCorreoService from '../../../services/api/historial_envio_correos';
import CorreoService from '../../../services/api/correos';
import CuotasOrdinariaService from '../../../services/api/cuotas_ordinaria';
import CuotasFondoService from '../../../services/api/cuotas_fondo';
import { CloseOutlined, PayCircleOutlined, DownloadOutlined } from '@ant-design/icons';
import apiConfig from '../../../services/api/config';
import { cargarConfiguracion } from '../../../data/configuracion/actions';
import store from '../../../store';
import moment from 'moment';
const { TabPane } = Tabs;
const FormItem = Form.Item;
const { Option } = Select;

class ShowPagoPendientes extends Component {
  state = {
    id: null,
    cargando: false,
    colegiado: {},
    destinatarios: [],
    cuotas_ordinaria: [],
    cuotas_fondo_mutual: [],
    cuota_ordinaria: {},
    cuota_fondo: {},
    active_tab: '1',
    es_adelantar_cuota: false,
    open_modal_cuota_ordinaria: false,
    open_modal_cuota_fondo: false,
    open_modal_raccionar: false,
    guardando_cuota_ordinaria: false,
    guardando_cuota_fondo: false,
    index_cuota_ordinaria: '',
    index_cuota_fondo: '',
    selectedRowKeys: [],
    seleccionados: [],
    detalle_deuda_colegiado: [],
    detalle_pagos_colegiado: [],
    detalle_deuda_colegiado_fracionamiento_count: 0,
    estado_cuentas: [],
    historial_envio_correos: [],
    pres_pagar: 0,
    producto: {},
    ordenAscendente: false
  };

  UNSAFE_componentWillMount() {
    if (this.props.location) {
      const queryString = new URLSearchParams(this.props.location.search);
      if (queryString) {
        const tipo_servicio_id = queryString.get('tipo_servicio_id');
        const es_adelantar_cuota = queryString.get('es_adelantar_cuota');
        this.setState({
          tipo_servicio_id,
          es_adelantar_cuota
        });
      }
    }
  }

  componentDidMount() {
    if (this.props.sinlogin) {
      store.dispatch(cargarConfiguracion());
    } else {
      localStorage.setItem('crearOVColegio', 'true');
    }

    if (this.props.match && this.props.match.params && this.props.match.params.id) {
      this.cargarColegiado(this.props.match.params.id);
    }
  }

  cargarColegiado = (id) => {
    this.setState({
      cargando: true,
      id,
    });

    ColegiadoService.getColegiadoPagoPendiente(
      id,
      (colegiado) => {
        if (colegiado) {
          this.setState({
            cargando: false,
            colegiado,
            cuotas_ordinaria: colegiado?.cuotas_ordinaria,
            cuotas_fondo_mutual: colegiado?.cuotas_fondo_mutual,
            pres_pagar: 0
          }, () => {
            if (this.state.producto_id) {
              const producto = colegiado.productos_deuda_colegiado.find((item) => item.id === this.state.producto_id);
              this.setState({producto});
            }
            if (this.state.tipo_servicio_id) {
              let PROD_DESCRIPCION = '';
              let PROD_DESCRIPCION_TEMP = '';
              if (this.state.tipo_servicio_id === 'FondoMutualDeFallecido') {
                PROD_DESCRIPCION = 'FONDO MORTUORIO';
                PROD_DESCRIPCION_TEMP = 'FONDO MORTUORIO ';
              } else if (this.state.tipo_servicio_id === 'FondoMutual') {
                PROD_DESCRIPCION = 'FONDO MORTUORIO';
                PROD_DESCRIPCION_TEMP = 'FONDO MORTUORIO ';
              } else if (this.state.tipo_servicio_id === 'CuotaOrdinaria') {
                PROD_DESCRIPCION = 'CUOTA ORDINARIA';
                PROD_DESCRIPCION_TEMP = 'CUOTA ORDINARIA ';
              } else if (this.state.tipo_servicio_id === 'Fraccionamiento') {
                PROD_DESCRIPCION = 'FRACCIONAMIENTO';
              }
              if (colegiado.productos_deuda_colegiado && colegiado.productos_deuda_colegiado.length >0) {
                let producto = colegiado.productos_deuda_colegiado.find((item) => item.PROD_DESCRIPCION === PROD_DESCRIPCION);

                const producto_temp = colegiado.productos_deuda_colegiado.find((item) => item.PROD_DESCRIPCION === PROD_DESCRIPCION_TEMP);

                if (producto_temp && producto_temp.id) {
                  producto = producto_temp;
                }

                if (producto) {
                  this.setState({
                      tipo_producto: producto.PROD_DESCRIPCION ? producto.PROD_DESCRIPCION: null,
                      tipo_producto_temp: producto.PROD_DESCRIPCION ? producto.PROD_DESCRIPCION: null,
                      producto_id: producto.id,
                      PERS_PERSONA_ID: producto.PERS_PERSONA_ID,
                      PROD_PRODUCTO_ID: producto.PROD_PRODUCTO_ID,
                  });

                  this.setState({producto}, () => {
                    this.cargarDetalleColegiado(true);
                  });
                }
              }
            }
          });
        }
      },
      (err, result) => {
        if (err) {
          message.error(err.message);
          this.setState({
            cargando: false,
          });
        }
      }
    );
  };

  handleCreateCuotaOrdinariaFormSubmit = (data) => {
    this.setState({ guardando_cuota_ordinaria: true });
    if (data.id) {
      CuotasOrdinariaService.updateCuotaOrdinaria(
        data,
        (response) => {
          if (response) {
            this.setState({
              guardando_cuota_ordinaria: false,
              open_modal_cuota_ordinaria: false,
              response,
            }, () => {
              this.changeCuotaOrdinaria(response, 'update', this.state.index_cuota_ordinaria);
            });
            message.success('Datos actualizados exitosamente');
          }
        },
        (error) => {
          if (error) {
            message.error(error.message);
            this.setState({
              guardando_cuota_ordinaria: false,
              open_modal_cuota_ordinaria: true,
            });
          }
        }
      );
    } else {
      CuotasOrdinariaService.createCuotaOrdinaria(
        data,
        (response) => {
          if (response) {
            this.setState({
              guardando_cuota_ordinaria: false,
              open_modal_cuota_ordinaria: false,
            }, () => {
              this.changeCuotaOrdinaria(response, 'create', 0);
            });
            // this.cargarUsers();
            message.success('Datos guardados exitosamente');
          }
        },
        (error) => {
          if (error) {
            message.error(error.message);
            this.setState({
              guardando_cuota_ordinaria: false,
              open_modal_cuota_ordinaria: true,
            });
          }
        }
      );
    }
  };


  handleCreateCuotaFondoFormSubmit = (data) => {
    this.setState({ guardando_cuota_fondo: true });
    if (data.id) {
      CuotasFondoService.updateCuotaFondo(
        data,
        (response) => {
          if (response) {
            this.setState({
              guardando_cuota_fondo: false,
              open_modal_cuota_fondo: false,
              response,
            }, () => {
              this.changeCuotaFondo(response, 'update', this.state.index_cuota_fondo);
            });
            message.success('Datos actualizados exitosamente');
          }
        },
        (error) => {
          if (error) {
            message.error(error.message);
            this.setState({
              guardando_cuota_fondo: false,
              open_modal_cuota_fondo: true,
            });
          }
        }
      );
    } else {
      CuotasFondoService.createCuotaFondo(
        data,
        (response) => {
          if (response) {
            this.setState({
              guardando_cuota_fondo: false,
              open_modal_cuota_fondo: false,
            }, () => {
              this.changeCuotaFondo(response, 'create', 0);
            });
            // this.cargarUsers();
            message.success('Datos guardados exitosamente');
          }
        },
        (error) => {
          if (error) {
            message.error(error.message);
            this.setState({
              guardando_cuota_fondo: false,
              open_modal_cuota_fondo: true,
            });
          }
        }
      );
    }
  };

  handleCreateFraccionarFormSubmit = (data) => {
    const seleccionados = [];
    if (this.state.seleccionados && this.state.seleccionados.length > 0) {
      this.state.seleccionados.map(item => {
        if (moment(item.fec_inicio, "DD-MM-YYYY").format('YYYYMMDD') <= moment().format('YYYYMMDD')) {
          seleccionados.push(item);
        }
        return null;
      })
    }

    data.seleccionados = seleccionados;
    data.colegiatura_id = this.state.colegiado.id;
    data.producto_id = this.state.producto_id;
    this.setState({ guardando_fraccionar: true });

    CuotasFondoService.createFraccionamiento(
      data,
      (response) => {
        if (response) {
          this.setState({
            guardando_fraccionar: false,
            open_modal_fraccionar: false,
            seleccionados: [],
            selectedRowKeys: []
          });

          this.cargarDetalleColegiado();
          message.success('Datos guardados exitosamente');
        }
      },
      (error) => {
        if (error) {
          message.error(error.message);
          this.setState({
            guardando_fraccionar: false,
            open_modal_fraccionar: true,
          });
        }
      }
    );
  };

  changeCuotaOrdinaria = (response, tipo, index = 0) => {
    const cuotas_ordinaria = [...this.state.cuotas_ordinaria];
    if (tipo === 'create') {
      cuotas_ordinaria.push(response);
      this.setState({
        cuotas_ordinaria
      });
    } else {
      cuotas_ordinaria[index] = response;
      this.setState({
        cuotas_ordinaria
      });
    }
  };

  changeCuotaFondo = (response, tipo, index = 0) => {
    const cuotas_fondo_mutual = [...this.state.cuotas_fondo_mutual];
    if (tipo === 'create') {
      cuotas_fondo_mutual.push(response);
      this.setState({
        cuotas_fondo_mutual
      });
    } else {
      cuotas_fondo_mutual[index] = response;
      this.setState({
        cuotas_fondo_mutual
      });
    }
  };

  handleOpenModalCuotaOrdinaria = () => {
    this.setState({
      open_modal_cuota_ordinaria: true
    });
  };

  handleClickCloseModalCuotaOrdinaria = (e) => {
    this.setState({
      open_modal_cuota_ordinaria: false,
    });
  };

  handleEditarCuotaOrdinaria = (cuota_ordinaria, index) => {
    this.setState({
      open_modal_cuota_ordinaria: true,
      cuota_ordinaria,
      index_cuota_ordinaria: index
    });
  };

  handleOpenModalCuotaFondo = () => {
    this.setState({
      open_modal_cuota_fondo: true
    });
  };

  handleClickCloseModalCuotaFondo = (e) => {
    this.setState({
      open_modal_cuota_fondo: false,
    });
  };

  handleEditarCuotaFondo = (cuota_fondo, index) => {
    this.setState({
      open_modal_cuota_fondo: true,
      cuota_fondo,
      index_cuota_fondo: index
    });
  };

  handleOpenModalFraccionar = () => {
    if (this.state.detalle_deuda_colegiado && this.state.seleccionados && this.state.detalle_deuda_colegiado.length !== this.state.seleccionados.length) {
      message.error('Debe seleccionar todas tus cuotas pendientes.');
      return true;
    }
    if (this.state.tipo_producto_temp === 'FRACCIONAMIENTO') {
      message.error('No se puede fraccionar es un producto de FRACCIONAMIENTO');
      return true;
    }
    if (this.state.seleccionados.length > 0) {
      this.setState({
        open_modal_fraccionar: true
      });  
    } else {
      message.error('Debe seleccionar registros de la tabla pendientes');
    }
    
  };

  handleClickCloseModalFraccionar = (e) => {
    this.setState({
      open_modal_fraccionar: false,
    });
  };

  handleChangeTipoProducto = (value, opt) => {
    const { producto } = opt.props;

    this.setState({
      tipo_producto: value,
      tipo_producto_temp: producto.PROD_DESCRIPCION,
      producto_id: producto.id,
      PERS_PERSONA_ID: producto.PERS_PERSONA_ID,
        PROD_PRODUCTO_ID: producto.PROD_PRODUCTO_ID,
      cargando_detalle: true,
      seleccionados: [],
      selectedRowKeys: [],
      pres_pagar: 0,
      producto
    }, () => {
        this.cargarDetalleColegiadoTemp();
    });
  }

  handleActualizar = () => {
    this.cargarDetalleColegiado();
    if (this.props.match && this.props.match.params && this.props.match.params.id) {
      this.cargarColegiado(this.props.match.params.id);
    }
  }

  cargarDetalleColegiadoTemp = () => {
    setTimeout(() => {
      console.log('cargando detalle colegiado');
      
      this.cargarDetalleColegiado();
    }, 180_000);
    this.cargarDetalleColegiado();
  }

  cargarDetalleColegiado = (es_negocios = false) => {
    this.setState({
      cargando_detalle: true,
    });
    
    ColegiadoService.getColegiadoDetalle(
      {
        id: this.state.colegiado.id ? this.state.colegiado.id: null,
        PERS_PERSONA_ID: this.state.PERS_PERSONA_ID,
        PROD_PRODUCTO_ID: this.state.PROD_PRODUCTO_ID,
        producto_id: this.state.producto_id,
        es_negocios,
        es_adelantar_cuota: this.state.es_adelantar_cuota || false,
      },
      (detalle) => {
        if (detalle) {

          let count_existe = 0;
          const estado_cuentas = detalle.estado_cuentas.map((item) => {
            if (item.saldo && parseFloat(item.saldo) > 0 && count_existe === 0) {
              count_existe += 1;
              return {
                ...item,
                saldo: parseFloat(item.saldo - (this.state.producto?.ADELANTO || 0)).toFixed(2),
                importe_deuda: parseFloat(item.importe_deuda - (this.state.producto?.ADELANTO || 0)).toFixed(2),
              };
            }
            return item;
          });

          this.setState({
            cargando_detalle: false,
            detalle_deuda_colegiado: detalle.detalle_deuda_colegiado,
            detalle_pagos_colegiado: detalle.detalle_pago_colegiado,
            detalle_deuda_colegiado_fracionamiento_count: detalle.detalle_deuda_colegiado_fracionamiento_count,
            estado_cuentas,
            selectedRowKeys: [],
            seleccionados : [],
          }, () => {
            this.crearNuevoCuota();
          });
        }
      },
      (err, result) => {
        if (err) {
          message.error(err.message);
          this.setState({
            cargando_detalle: false,
          });
        }
      }
    );
  }

  cargarHistorialEnvioCorreo = (es_negocios = false) => {
    this.setState({
      cargando_historial_envio_correos: true,
    });
    
    HistorialEnvioCorreoService.getHistorialEnvioCorreo(
        this.state.colegiado.id ? this.state.colegiado.id: null
      ,
      (response) => {
        if (response) {
          this.setState({
            cargando_historial_envio_correos: false,
            historial_envio_correos: response,
          }, () => {
            this.crearNuevoCuota();
          });
        }
      },
      (err, result) => {
        if (err) {
          message.error(err.message);
          this.setState({
            cargando_historial_envio_correos: false,
          });
        }
      }
    );
  }

  crearNuevoCuota = () => {
    // Luego, en otro lugar de tu código:
    if (localStorage.getItem('crearOVColegio') !== 'true') {
        this.handleClickCrearOVCoelgio();
        localStorage.setItem('crearOVColegio', 'true');
    }
  }

  onSelectChange = (selectedRowKeys, seleccionados) => {
    let ordenAscendente = true;
    for (let i = 0; i < selectedRowKeys.length; i++) { 
      if (selectedRowKeys[i] !== i) { 
        ordenAscendente = false;
        break; 
      } 
    }

    const array_check = [];
    seleccionados.map((item, index) => {
      if (moment(item.FEC_EMISION, "DD-MM-YYYY").format('YYYYMMDD') <= moment().endOf('month').format('YYYYMMDD')) {
        array_check.push(index);
      }
      return null;
    });

    if (this.state.producto && (this.state.producto.PROD_DESCRIPCION === 'CUOTA ORDINARIA' || this.state.producto.PROD_DESCRIPCION === 'CUOTA ORDINARIA ')) {
      const { colegiado } = this.state;
      if (colegiado.productos_deuda_colegiado && colegiado.productos_deuda_colegiado.length >0) {
        const producto = colegiado.productos_deuda_colegiado.find((item) => item.PROD_DESCRIPCION === 'FRACCIONAMIENTO' && item.computed1);
        if (producto && producto.id && this.state.detalle_deuda_colegiado_fracionamiento_count > 0) {
          const fechaMoment = moment(producto.Fecha_Vencimiento, "YYYY-MM-DD HH:mm:ss");
          let contador_error = 0;
          
          let deuda_precio = 0;
          seleccionados.map((item, index) => {
            if (!(moment(item.FEC_EMISION, "DD-MM-YYYY").startOf('month') <= fechaMoment)) {
              contador_error += 1;
              deuda_precio = parseFloat(item.DEUDA);
            }
            return null;
          });

          if (!(this.state.producto && parseFloat(this.state.producto?.ADELANTO) >= deuda_precio)) {
            console.log('Aver si deciden otra jajaja');
            
          }
          if (contador_error > 0) {
            message.error('Tiene cuotas de fraccionamiento pendientes a pagar.');
            return true;
          }
        }
      }
    }

    this.setState({ selectedRowKeys, seleccionados, ordenAscendente });
  };

  handleAdelantoEfectivo = () => {
    if (this.state.detalle_deuda_colegiado && this.state.detalle_deuda_colegiado.length > 0) {
      message.error('No se puede adelantar debido a pagos pendientes.');
      return true;
    }
    
    let url_producto = '';
    if (this.state.tipo_producto_temp === 'FONDO MORTUORIO ') {
      url_producto = this.props.configuracion?.adelanto_fondo_mortuorio;
    }
    if (this.state.tipo_producto_temp === 'FONDO MORTUORIO') {
      url_producto = this.props.configuracion?.adelanto_fondo_mortuorio;
    }

    const href = `${url_producto}&colegiado_id=${this.state.colegiado?.id}&numero_documento=${this.state.colegiado.numero_documento}&codigo_afiliado=${this.state.colegiado.codigo_afiliado}&sinlogin=${this.props.sinlogin}&colegio_producto_id=${this.state.producto_id}`;

    window.open(href);
  }

  handlePagoEfectivo = () => {
    const seleccionados = [];
    if (this.state.seleccionados && this.state.seleccionados.length > 0) {
      this.state.seleccionados.map((item) => {
        seleccionados.push({
          DEUDA: item.DEUDA,
          FEC_EMISION: item.FEC_EMISION,
          DESCRIPCION: item.DESCRIPCION,
          CORREL: item.CORREL,
          SERIE: item.SERIE,
          colegiatura_id: item.colegiatura_id,
          deleted_at: item.deleted_at,
          es_fraccionamiento_especial: item.es_fraccionamiento_especial,
          es_negocios: item.es_negocios,
          es_pagado: item.es_pagado,
          id: item.id,
          key: item.key,
          fec_inicio: item.fec_inicio ? item.fec_inicio: null,
          producto_id: item.producto_id,
          updated_at: item.updated_at,
        });
        return item;
      });
    }

    let deuda_total = 0;
    seleccionados.map((item, index) => {
      deuda_total += parseFloat(item.DEUDA);
      return null;
    });

    if (this.state.producto && parseFloat(this.state.producto?.ADELANTO) >= deuda_total) {
      message.error('Tu monto total es mayor que el adelanto, pero este no se puede pagar.');
      return true;
    }

    if (this.state.pres_pagar > 0) {
      message.error('Para continuar, por favor actualiza.');
      return true;
    }
    if (!this.state.ordenAscendente) {
      message.error('Por favor seleccionar tus cuotas pendientes en orden.');
      return true;
    }
    if (this.state.seleccionados && this.state.seleccionados.length > 0) {
      const result = this.state.seleccionados.find(item => item.es_fraccionamiento_especial === 1);

      if(result && result.id) {
        if (this.state.seleccionados.length > 1) {
          message.error('Primero debe pagar el inicial del fraccionamiento.');
          return true;
        }
      }
    }

    if (this.state.seleccionados.length > 0) {

      let url_producto = '';
      if (this.state.tipo_producto_temp === 'CUOTA ORDINARIA') {
        url_producto = this.props.configuracion.cuota_ordinaria ? this.props.configuracion.cuota_ordinaria: null;
      } else if (this.state.tipo_producto_temp === 'FRACCIONAMIENTO') {
        url_producto = this.props.configuracion.fraccionamiento ? this.props.configuracion.fraccionamiento: null;
      } else if (this.state.tipo_producto_temp === 'FONDO MORTUORIO ') {
        url_producto = this.props.configuracion.fondo_mortuorio ? this.props.configuracion.fondo_mortuorio: null;
      } else if (this.state.tipo_producto_temp === 'FONDO MORTUORIO') {
        url_producto = this.props.configuracion.fondo_mortuorio ? this.props.configuracion.fondo_mortuorio: null;
      }

      ColegiadoService.createPagoCache({
        pendientes: seleccionados,
        id: this.state.colegiado?.id,
        producto_id: this.state.producto_id
      },  (detalle) => {

      });
      
      const href = `${url_producto}&colegiado_id=${this.state.colegiado?.id}&numero_documento=${this.state.colegiado.numero_documento}&colegio_producto_id=${this.state.producto_id}&sinlogin=${this.props.sinlogin}&pagar_por=${this.state.tipo_producto}&adelanto=${this.state.producto.ADELANTO ? this.state.producto.ADELANTO: 0}&user_email=${this.props.user && this.props.user.email ? this.props.user.email: ''}`;

      this.setState({
        pres_pagar: 1
      });
      if (this.props.es_fraccionamiento) {
        window.open(href);
      } else {
        window.open(href);
      }
    } else {
      message.error('Debe seleccionar registros de la tabla pendientes');
    }
  }

  handleExportar = (tipo) => {
    const page = Object.assign({}, this.state.page);
    let path = `?page=${page.number}&per_page=${page.per_page}&order_column=${page.order_column}&order_type=${page.order_type}&estado=${this.state.estado}&de=${this.state.de_formato}&hasta=${this.state.hasta_formato}`;
    if (page.buscar_texto !== undefined || page.buscar_texto !== '') {
      path = `${path}&buscar_texto=${page.buscar_texto}`;
    }
    const token =  localStorage.getItem(apiConfig.constants.ACCESS_TOKEN_KEY) || null;
    const url_exportar = `${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/detalles-pago-colegiado/${this.state.producto_id}/xls${path}&authorization=${token}`;
    window.open(url_exportar);
  }

  handleExportarEstadoCuenta = (tipo) => {
    if (tipo === 'pdf') {
      const page = Object.assign({}, this.state.page);
      let path = `?PERS_PERSONA_ID=${this.state.PERS_PERSONA_ID}&PROD_PRODUCTO_ID=${this.state.PROD_PRODUCTO_ID}&producto_id=${this.state.producto_id}&page=${page.number}&per_page=${page.per_page}&order_column=${page.order_column}&order_type=${page.order_type}&estado=${this.state.estado}&de=${this.state.de_formato}&hasta=${this.state.hasta_formato}`;
      if (page.buscar_texto !== undefined || page.buscar_texto !== '') {
        path = `${path}&buscar_texto=${page.buscar_texto}`;
      }
      const token =  localStorage.getItem(apiConfig.constants.ACCESS_TOKEN_KEY) || null;
      const url_exportar = `${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/colegiados-detalle/${this.state.colegiado.id ? this.state.colegiado.id: null}/pdf${path}&authorization=${token}`;
      window.open(url_exportar);
    } else {
      const page = Object.assign({}, this.state.page);
      let path = `?PERS_PERSONA_ID=${this.state.PERS_PERSONA_ID}&PROD_PRODUCTO_ID=${this.state.PROD_PRODUCTO_ID}&producto_id=${this.state.producto_id}&page=${page.number}&per_page=${page.per_page}&order_column=${page.order_column}&order_type=${page.order_type}&estado=${this.state.estado}&de=${this.state.de_formato}&hasta=${this.state.hasta_formato}`;
      if (page.buscar_texto !== undefined || page.buscar_texto !== '') {
        path = `${path}&buscar_texto=${page.buscar_texto}`;
      }
      const token =  localStorage.getItem(apiConfig.constants.ACCESS_TOKEN_KEY) || null;
      const url_exportar = `${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/colegiados-detalle/${this.state.colegiado.id ? this.state.colegiado.id: null}/xls${path}&authorization=${token}`;
      window.open(url_exportar);
    }
  }

  handleClickExportarPDF = () => {
    const token = localStorage.getItem(apiConfig.constants.ACCESS_TOKEN_KEY) || null;
    const url_exportar = `${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/detalles-deuda-colegiado/${this.state.colegiado.id ? this.state.colegiado.id: null}/pdf?PERS_PERSONA_ID=${this.state.PERS_PERSONA_ID}&PROD_PRODUCTO_ID=${this.state.PROD_PRODUCTO_ID}&producto_id=${this.state.producto_id}&es_negocios=false&authorization=${token}`;
    window.open(url_exportar);
  };

  handleClickCrearOVCoelgio = () => {
    this.setState({
      loading_ov_colegio: true
    });

    if (this.state.colegiado && this.state.colegiado.id) {
      ColegiadoService
        .crearOVCuentaColegio(
          {
            id: this.state.colegiado.id,
            numero_documento: this.state.colegiado.numero_documento,
            codigo_afiliado: this.state.colegiado.codigo_afiliado
          },
          (response) => {
            if (response) {
              this.setState({
                loading_ov_colegio: false
              }, () => {
                this.handleActualizar();
              });
            }
          },
          (error) => {
            if (error) {
              message.error(error.message);
            }
            this.setState({
              loading_ov_colegio: false
            });
          }
        )
    } else {
      this.setState({
        loading_ov_colegio: false
      });
    }
  }

  handleEnviarCorreoDeuda = () => {
    this.setState({enviando_coreo: true});
    CorreoService.enviarCorreoDeuda({
      id: this.state.colegiado?.id,
      user_name: this.props.user && this.props.user.name ? this.props.user.name: '',
      user_id: this.props.user && this.props.user.id ? this.props.user.id: '',
    },  (response) => {
      if (response) {
        message.success('✅ ¡Proceso completado con éxito!');
        this.setState({enviando_coreo: false, enviando_coreo_message: true});
      }
    }, (error) => {
      if (error) {
        message.error(error.message);
        this.setState({enviando_coreo: false});
      }
    });
  }

  handleChangeTab = (key) => {
    if (key === '5') {
      this.cargarHistorialEnvioCorreo();
    }
  }

  render() {
    const { colegiado } = this.state;
    const adelanto = (this.state.producto && this.state.producto.ADELANTO ? this.state.producto.ADELANTO: 0);
  
    const detalle_deuda_colegiado = [];
    let total_pendiente = 0;
    if (this.state.detalle_deuda_colegiado && this.state.detalle_deuda_colegiado.length > 0) {
      this.state.detalle_deuda_colegiado.map((item, index) => {
        item.key = index;
        total_pendiente += parseFloat(item.DEUDA);
        if (index === 0) {
          total_pendiente -= adelanto;       
        }
        detalle_deuda_colegiado.push(item);
        return null;
      });
    }

    let total_pago = 0;
    if (this.state.detalle_pagos_colegiado && this.state.detalle_pagos_colegiado.length > 0) {
      this.state.detalle_pagos_colegiado.map((item, index) => {
        total_pago += parseFloat(item.IMPORTE);
        return null;
      });
    }
    
    // const columns_cuota_ordinaria = [
    //   {
    //     title: 'Fecha Emisión',
    //     dataIndex: 'fecha_emision',
    //     key: 'fecha_emision',
    //     responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
    //   },
    //   {
    //     title: 'Comprobante',
    //     dataIndex: 'comprobante',
    //     key: 'comprobante',
    //     responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
    //   },
    //   {
    //     title: 'Monto',
    //     dataIndex: 'monto',
    //     key: 'monto',
    //     responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
    //   },
    //   {
    //     title: 'Comentario',
    //     dataIndex: 'comentario',
    //     key: 'comentario',
    //     responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
    //   },
    //   {
    //     title: 'Acción',
    //     dataIndex: 'action',
    //     key: 'action',
    //     responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
    //     render: (text, record, index) => (
    //       <Space size="middle">
    //         <a style={{ color: '#0045ad' }} onClick={() => this.handleEditarCuotaOrdinaria(record, index)}>Editar</a>
    //       </Space>
    //     ),
    //   },
    // ];

    // const columns_cuota_fondo_mutual = [
    //   {
    //     title: 'Fecha Emisión',
    //     dataIndex: 'fecha_emision',
    //     key: 'fecha_emision',
    //     responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
    //   },
    //   {
    //     title: 'Comprobante',
    //     dataIndex: 'comprobante',
    //     key: 'comprobante',
    //     responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
    //   },
    //   {
    //     title: 'Monto',
    //     dataIndex: 'monto',
    //     key: 'monto',
    //     responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
    //   },
    //   {
    //     title: 'Comentario',
    //     dataIndex: 'comentario',
    //     key: 'comentario',
    //     responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
    //   },
    //   {
    //     title: 'Acción',
    //     dataIndex: 'action',
    //     key: 'action',
    //     responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
    //     render: (text, record, index) => (
    //       <Space size="middle">
    //         <a style={{ color: '#0045ad' }} onClick={() => this.handleEditarCuotaFondo(record, index)}>Editar</a>
    //       </Space>
    //     ),
    //   },
    // ];

    const columns_ultimo_pago = [
      {
        title: 'SITUACIÓN',
        dataIndex: 'computed1',
        key: 'computed1',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'ÚLTIMO PAGO',
        dataIndex: 'Fecha_Pago_temp',
        key: 'Fecha_Pago_temp',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'ÚLTIMO VENCIMIENTO',
        dataIndex: 'Fecha_Vencimiento_temp',
        key: 'Fecha_Vencimiento_temp',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        render: (text, record, index) => {
          return <div>
            {
              record.Fecha_Vencimiento_temp ? record.Fecha_Vencimiento_temp: (this.state.colegiado && this.state.colegiado.fecha_ultimo_pago ? this.state.colegiado.fecha_ultimo_pago: null)
            }
          </div>;
        },
      },
      {
        title: 'ADELANTO',
        dataIndex: 'ADELANTO',
        key: 'ADELANTO',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
    ];

    let columns_pendiente = [];
    if (this.state.tipo_producto_temp === 'FRACCIONAMIENTO') {
      columns_pendiente = [
        {
          title: 'FEC. ORDEN',
          dataIndex: 'FEC_EMISION',
          key: 'FEC_EMISION',
          responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        },
        {
          title: 'SERIE',
          dataIndex: 'SERIE',
          key: 'SERIE',
          responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        },
        {
          title: 'NRO. CORRELATIVO',
          dataIndex: 'CORREL',
          key: 'CORREL',
          responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        },
        {
          title: 'PRODUCTO',
          dataIndex: 'DESCRIPCION',
          key: 'DESCRIPCION',
          responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        },
        {
          title: `TOTAL ${total_pendiente.toFixed(2)}`,
          dataIndex: 'DEUDA',
          key: 'DEUDA',
          className: 'text-right',
          responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        },
      ];
    } else {
      columns_pendiente = [
        {
          title: 'FEC. ORDEN',
          dataIndex: 'fec_inicio',
          key: 'fec_inicio',
          responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
          render: (text, record, index) => {
            if (moment(record.FEC_EMISION, "DD-MM-YYYY").format('YYYYMMDD') <= moment().endOf('month').format('YYYYMMDD')) {
              return <div style={{ borderLeft: '2px solid #14b403', paddingLeft: 8 }}>{record.fec_inicio}</div>;
            } else {
              return <div style={{ borderLeft: '2px solid #fff', paddingLeft: 8 }}>{record.fec_inicio}</div>;
            }
          },
        },
        {
          title: 'FEC. VENCIMIENTO',
          dataIndex: 'FEC_EMISION',
          key: 'FEC_EMISION',
          responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        },
        {
          title: 'SERIE',
          dataIndex: 'SERIE',
          key: 'SERIE',
          responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        },
        {
          title: 'NRO. CORRELATIVO',
          dataIndex: 'CORREL',
          key: 'CORREL',
          responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        },
        {
          title: 'PRODUCTO',
          dataIndex: 'DESCRIPCION',
          key: 'DESCRIPCION',
          responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        },
        {
          title: `TOTAL ${total_pendiente.toFixed(2)}`,
          dataIndex: 'DEUDA',
          key: 'DEUDA',
          className: 'text-right',
          responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
          render: (text, record, index) => {
            return <div>
              {
                index === 0 ?
                (parseFloat(text) - adelanto).toFixed(2):
                text
              }
            </div>
          }
        },
      ];
    }

    const columns_pago = [
      {
        title: 'AÑO',
        dataIndex: 'ANIO',
        key: 'ANIO',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'FECHA RECIBO',
        dataIndex: 'FECHA_EMISION',
        key: 'FECHA_EMISION',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'FECHA VENCIMIENTO',
        dataIndex: 'FECHA_VENCIMIENTO',
        key: 'FECHA_VENCIMIENTO',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'SERVICIO',
        dataIndex: 'SERVICIO',
        key: 'SERVICIO',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        render: (text, record, index) => {
          return <div title={record.DESCRIPCION ? record.DESCRIPCION: ''}>
            {
              record.DESCRIPCION && record.DESCRIPCION.length > 20 ?
              <b>{record.DESCRIPCION === 'PAGO PARCIAL'? record.DESCRIPCION:null} {record.DESCRIPCION === 'FONDO MORTUORIO FALLECIDO' ? record.DESCRIPCION: record.DESCRIPCION === 'ADELANTO FONDO MORTUORIO' ? record.DESCRIPCION:text }</b>
              :<>{record.DESCRIPCION === 'PAGO PARCIAL'? record.DESCRIPCION:null} {record.DESCRIPCION === 'FONDO MORTUORIO FALLECIDO' ? record.DESCRIPCION: record.DESCRIPCION === 'ADELANTO FONDO MORTUORIO' ? record.DESCRIPCION:text }</>
            }
          </div>;
        },
      },
      {
        title: 'IMPORTE DEUDA',
        dataIndex: 'IMPORTE_DEUDA',
        key: 'IMPORTE_DEUDA',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'SALDO',
        dataIndex: 'SALDO',
        key: 'SALDO',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'FECHA PAGO',
        dataIndex: 'FECHA_PAGO',
        key: 'FECHA_PAGO',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'COMPROBANTE',
        dataIndex: 'NRO_COMPROBANTE',
        key: 'NRO_COMPROBANTE',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: `IMPORTE PAGO ${total_pago.toFixed(2)}`,
        dataIndex: 'IMPORTE',
        key: 'IMPORTE',
        className: 'text-right',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
    ];

    const columns_estado_cuenta = [
      {
        title: 'AÑO',
        dataIndex: 'anio',
        key: 'anio',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'FECHA RECIBO',
        dataIndex: 'fecha_emision',
        key: 'fecha_emision',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'FECHA VENCIMIENTO',
        dataIndex: 'fecha_vencimiento',
        key: 'fecha_vencimiento',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'SERVICIO',
        dataIndex: 'servicio',
        key: 'servicio',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        render: (text, record, index) => {
          return <div title={record.descripcion ? record.DESCRIPCION: ''}>
            {
              record.descripcion && record.descripcion.length > 20 ?
              <b>{record.descripcion === 'PAGO PARCIAL'? record.descripcion:null} {record.descripcion === 'FONDO MORTUORIO FALLECIDO' ? record.descripcion: record.descripcion === 'ADELANTO FONDO MORTUORIO' ? record.descripcion:text }</b>
              :<>{record.descripcion === 'PAGO PARCIAL'? record.descripcion:null} {record.descripcion === 'FONDO MORTUORIO FALLECIDO' ? record.descripcion: record.descripcion === 'ADELANTO FONDO MORTUORIO' ? record.descripcion:text }</>
            }
          </div>;
        },
      },
      {
        title: 'IMPORTE DEUDA',
        dataIndex: 'importe_deuda',
        key: 'importe_deuda',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'SALDO',
        dataIndex: 'saldo',
        key: 'saldo',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'FECHA PAGO',
        dataIndex: 'fecha_pago',
        key: 'fecha_pago',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'COMPROBANTE',
        dataIndex: 'numero_comprobante',
        key: 'numero_comprobante',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: `IMPORTE PAGO`,
        dataIndex: 'importe',
        key: 'importe',
        className: 'text-right',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
    ];

  const columns_historial_envio_correos = [
    {
      title: 'Tipo',
      dataIndex: 'tipo',
      key: 'tipo',
      ellipsis: true,
      width: 120,
      responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
    },
    {
      title: 'Destinatario',
      dataIndex: 'destinatario',
      key: 'destinatario',
      ellipsis: true,
      width: 220,
      responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
    },
    {
      title: 'ASUNTO',
      dataIndex: 'asunto',
      key: 'asunto',
      ellipsis: true,
      width: 320,
      responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
    },
    {
      title: 'Estado',
      dataIndex: 'estado',
      key: 'estado',
      align: 'center',
      width: 120,
      render: (estado) => {
        let color = 'default';
        switch ((estado || '').toLowerCase()) {
          case 'enviado':
            color = 'green';
            break;
          case 'pendiente':
            color = 'orange';
            break;
          case 'fallido':
            color = 'red';
            break;
          case 'error':
            color = 'red';
            break;
          default:
            color = 'blue';
        }
        return <Tag color={color}>{estado}</Tag>;
      },
    },
    {
      title: 'FECHA ENVÍO',
      dataIndex: 'fecha_envio',
      key: 'fecha_envio',
      align: 'right',
      width: 150,
      ellipsis: true,
      responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
    },
  ];

    const { selectedRowKeys } = this.state;

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };

    let importe_total = 0;
    let importe_total_general = 0;
    let importe_total_fecha_ini = '';
    let importe_total_fecha_fin = '';
    if(this.state.seleccionados.length > 0) {
      this.state.seleccionados.map((item, index) => {
        importe_total_general += parseFloat(item.DEUDA);
        if (moment(item.fec_inicio, "DD-MM-YYYY").format('YYYYMMDD') <= moment().format('YYYYMMDD')) {
          importe_total += parseFloat(item.DEUDA);
          if (index === 0) {
            importe_total_fecha_ini = item.FEC_EMISION;
          }
          importe_total_fecha_fin = item.FEC_EMISION;
        }
        return null;
      })
    }

    if (this.state.producto && this.state.producto.ADELANTO && this.state.producto.ADELANTO > 0 && importe_total_general > 0) {
      importe_total_general = importe_total_general - this.state.producto?.ADELANTO;
    }

    const ultima_cuota = detalle_deuda_colegiado[detalle_deuda_colegiado.length - 1];
    const ultimo_anio_ov = ultima_cuota ? (parseFloat(ultima_cuota?.FEC_EMISION.substring(6, 10)) + 1): '';

    return (
      <div>
        {
          this.state.enviando_coreo_message &&
          <Alert
          style={{ marginBottom: 16 }}
            type='success'
            message={<div>
              🎉 ¡Todo listo! <br/>
              El correo fue enviado con éxito. ¡Gracias por tu paciencia y confianza!
            </div>}/>
        }
        
        <Spin spinning={this.state.cargando}>
          {
            this.props.sinlogin ?
            <>
              {
              !this.props.es_fraccionamiento &&
                <div className="colegiatura__header">
                  <div style={{ maxWidth: 100, margin: 'auto' }}>
                    <img src="https://www.ccpll.org/assets/img/logo.png" alt="Logo" />
                  </div>
                </div>
              }
              <div style={{ maxWidth: 950, margin: 'auto', paddingTop: 16 }}>
                <Row>
                  {
                    !this.props.es_fraccionamiento &&
                    <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                      <FormItem label="Producto." required={false}>
                        <Select
                          showSearch
                          optionFilterProp="children"
                          value={this.state.tipo_producto}
                          onChange={this.handleChangeTipoProducto}
                          disabled={true}
                          notFoundContent={'No se ha encontrado registros'}
                          id="tipo_producto"
                          autofocus="true"
                        >
                          {
                            colegiado &&
                            colegiado.productos_deuda_colegiado &&
                            colegiado.productos_deuda_colegiado.length > 0 &&
                            colegiado.productos_deuda_colegiado.map((item, index) => {
                              return (
                                <Option key={index} producto={item} value={`${item.PROD_DESCRIPCION} ${item.computed1 ? '-': ''} ${item.computed1}`}>
                                  {item.PROD_DESCRIPCION} {item.computed1 ? '-': ''} {item.computed1} {item.es_negocios ? '': ''}
                                </Option>
                              );
                            })
                          }
                        </Select>
                      </FormItem>
                    </Col>
                  }
                  {
                    <>
                      {
                        !this.props.es_fraccionamiento && !this.state.es_adelantar_cuota &&
                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                          <div style={{ display: 'flex', flexWrap: 'wrap', columnGap: 6, justifyContent: 'end' }}>
                            {
                              <Button onClick={this.handlePagoEfectivo} type="primary" shape="round" icon={<PayCircleOutlined />} size={null}>
                                Pagar 
                              </Button>
                            }
                          </div>
                        </Col>
                      }
                      {
                        this.state.es_adelantar_cuota &&
                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                          <div style={{ display: 'flex', flexWrap: 'wrap', columnGap: 6, justifyContent: 'end' }}>
                            {
                              <Button shape="round" onClick={this.handleClickCrearOVCoelgio} loading={this.state.loading_ov_colegio} type='ghost' style={{ background: 'green', border: 'green', color: 'white' }}>
                                {
                                  this.state.loading_ov_colegio ?
                                  'creando...':
                                  <>Nueva cuota OV {ultimo_anio_ov}</>
                                }
                              </Button>
                            }
                            {
                              <Button onClick={this.handlePagoEfectivo} type="primary" shape="round" icon={<PayCircleOutlined />} size={null}>
                                Pagar 
                              </Button>
                            }
                          </div>
                        </Col>
                      }
                    </>
                  }
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <h2><b>Pendientes ({detalle_deuda_colegiado.length}):</b></h2>
                        <div><h3 style={{ color: 'green' }}><b>Total:</b> { importe_total_general.toFixed(2) }</h3></div>
                      </div>
                      {
                        !this.state.ordenAscendente && this.state.seleccionados.length > 0 &&
                        <Alert message="Por favor seleccionar tus cuotas pendientes en orden." type="error" showIcon />
                      }
                      <Table
                          style={{ marginTop: 12 }}
                          columns={columns_pendiente}
                          rowSelection={rowSelection}
                          rowKey={(record) => record.key}
                          dataSource={detalle_deuda_colegiado}
                          pagination={false}
                          size="small"
                          loading={this.state.cargando_detalle}
                          locale={{
                            emptyText: 'No se ha encontrado registros',
                          }}
                        />
                    </Col>
                  </Row>
                  {
                    this.props.es_fraccionamiento &&
                    <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                      <div style={{ paddingTop: 16 }}>
                        {
                          <Button style={{ background: '#1890ff', border: '1px solid #1890ff' }} onClick={this.handlePagoEfectivo} type="primary" size="large" block  icon={<PayCircleOutlined />}>
                            Continuar 
                          </Button>
                        }
                      </div>
                    </Col>
                  }
              </div>
            </>: 
            <>
              <div className="page-header">
                <h2 className="page-header">{colegiado.nombres ? colegiado.nombres : 'Detalle Gestión De Solicitudes De Colegiatura'}</h2>
                <div style={{ display: 'flex', flexWrap: 'wrap', columnGap: 6 }}>
                  <Button type='primary' shape="round" style={{ background: 'green', border: 'green' }} loading={this.state.enviando_coreo} onClick={this.handleEnviarCorreoDeuda}>Enviar Correo Deuda</Button>
                  {/* {
                    this.state.tipo_producto_temp === 'FONDO MORTUORIO ' &&
                    <div>
                      <Button onClick={this.handleAdelantoEfectivo} type="primary" shape="round" icon={<PayCircleOutlined />} size={null}>
                        Generar Adelanto
                      </Button>
                    </div>
                  }
                  <div>
                    {
                      this.state.tipo_producto_temp && 
                      <Button onClick={this.handlePagoEfectivo} type="primary" shape="round" icon={<PayCircleOutlined />} size={null}>
                        Pagar 
                      </Button>
                    }
                  </div> */}
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card__body">
                      <div
                        style={{
                          position: 'absolute',
                          right: '48px',
                          fontSize: '20px',
                          zIndex: 10,
                        }}
                      >
                        <Link to={`/pago-pendientes`}>
                          <CloseOutlined />
                        </Link>
                      </div>
                      <Tabs defaultActiveKey={this.state.active_tab} onChange={this.handleChangeTab}>
                        <TabPane tab="Información General" key="1">
                          <Row>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} className="line-height-28">
                              <div>
                                <b>Estado: </b>
                                <Tag
                                  color={
                                    colegiado.estado_afiliado_formato === 'HABIL'
                                      ? 'green'
                                      : colegiado.estado_afiliado_formato === 'VITALICIO'
                                      ? 'red'
                                      : colegiado.estado_afiliado_formato === 'INHABILITADO POR DEUDA'
                                      ? 'blue'
                                      : ''
                                  }
                                >
                                  {colegiado.estado_afiliado_formato}
                                </Tag>
                              </div>
                              <div>
                                <b>RUC/DNI: </b> {colegiado.numero_documento}
                              </div>
                              <div>
                                <b>Nombres: </b>{' '}
                                {colegiado.nombres}
                              </div>
                              <div>
                                <b>Código Afiliado : </b> {colegiado.codigo_afiliado}
                              </div>
                              <div>
                                <b>Fecha Colegiatura: </b> {colegiado.fecha_colegiatura_1_temp}
                              </div>
                              <div>
                                <b>Correo electrónico: </b> {colegiado.correo_electronico}
                              </div>
                            </Col>
                          </Row>
                        </TabPane>
                        <TabPane tab="Pagos Pendientes" key="2">
                          <Row>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                              <FormItem label="Producto" required={false}>
                                <Select
                                  showSearch
                                  optionFilterProp="children"
                                  value={this.state.tipo_producto}
                                  onChange={this.handleChangeTipoProducto}
                                  disabled={this.state.es_duplicar}
                                  notFoundContent={'No se ha encontrado registros'}
                                  id="tipo_producto"
                                  autofocus="true"
                                >
                                  {
                                    colegiado &&
                                    colegiado.productos_deuda_colegiado &&
                                    colegiado.productos_deuda_colegiado.length > 0 &&
                                    colegiado.productos_deuda_colegiado.map((item, index) => {
                                      return (
                                        <Option key={index} producto={item} value={`${item.PROD_DESCRIPCION} ${item.computed1 ? '-': ''} ${item.computed1}`}>
                                          {item.PROD_DESCRIPCION} {item.computed1 ? '-': ''} {item.computed1} {item.es_negocios ? '': ''}
                                        </Option>
                                      );
                                    })
                                  }
                                </Select>
                              </FormItem>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                              <div style={{ display: 'flex', flexWrap: 'wrap', columnGap: 6, justifyContent: 'end' }}>
                                <Button type='primary' shape="round" loading={this.state.cargando_detalle} style={{ background: 'green', border: 'green' }} onClick={this.handleActualizar}>Actualizar</Button>
                                <Button shape="round" onClick={this.handleClickCrearOVCoelgio} loading={this.state.loading_ov_colegio} className="detalle__buttton__margin--left">
                                  Crear OV 
                                  {/* {this.state.cuenta && this.state.cuenta.anio_cuota_ordinaria ? parseInt(this.state.cuenta.anio_cuota_ordinaria) + 1: ''} C.O. */}
                                </Button>
                                {
                                  this.state.tipo_producto_temp === 'CUOTA ORDINARIA' &&
                                  <Button type='primary' shape="round" onClick={this.handleOpenModalFraccionar}>Fraccionar</Button>
                                }
                                
                                {
                                  this.state.tipo_producto_temp === 'FONDO MORTUORIO' &&
                                    <Button onClick={this.handleAdelantoEfectivo} type="primary" shape="round" icon={<PayCircleOutlined />} size={null}>
                                      Generar Adelanto
                                    </Button>
                                }
                                {
                                  this.state.tipo_producto_temp === 'FONDO MORTUORIO ' &&
                                    <Button onClick={this.handleAdelantoEfectivo} type="primary" shape="round" icon={<PayCircleOutlined />} size={null}>
                                      Generar Adelanto
                                    </Button>
                                }
                                {
                                  this.state.tipo_producto_temp && 
                                  <Button onClick={this.handlePagoEfectivo} type="primary" shape="round" icon={<PayCircleOutlined />} size={null}>
                                    Pagar 
                                  </Button>
                                }
                            </div>
                            </Col>

                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                              <h2><b>Último Pago:</b></h2>
                              <Table
                                  style={{ marginTop: 12 }}
                                  rowKey={(record) => record.id}
                                  columns={columns_ultimo_pago}
                                  dataSource={[this.state.producto]}
                                  pagination={false}
                                  size="small"
                                  locale={{
                                    emptyText: 'No se ha encontrado registros',
                                  }}
                                />
                            </Col>
                            
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <br/>
                              <div style={{ display: 'flex', justifyContent: 'space-between'}}>
                                <h2><b>Pendientes ({detalle_deuda_colegiado.length}):</b></h2>
                                <div><h3 style={{ color: 'green' }}><b>Total:</b> { importe_total_general.toFixed(2) }</h3></div>
                                {
                                  this.state.tipo_producto_temp === 'FRACCIONAMIENTO' &&
                                  <Button onClick={this.handleClickExportarPDF} type="primary" shape="round" icon={<DownloadOutlined />} size={null}>
                                    Descargar Fraccionamiento PDF
                                  </Button>
                                }
                              </div>
                              {
                                !this.state.ordenAscendente && this.state.seleccionados.length > 0 &&
                                <Alert message="Por favor seleccionar tus cuotas pendientes en orden." type="error" showIcon />
                              }
                              <Table
                                  style={{ marginTop: 12 }}
                                  columns={columns_pendiente}
                                  rowSelection={rowSelection}
                                  rowKey={(record) => record.key}
                                  dataSource={detalle_deuda_colegiado}
                                  pagination={false}
                                  size="small"
                                  loading={this.state.cargando_detalle}
                                  locale={{
                                    emptyText: 'No se ha encontrado registros',
                                  }}
                                />
                            </Col>
                          </Row>
                        </TabPane>
                        <TabPane tab="Historial de pagos" key="3">
                          <Row>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                              <FormItem label="Producto" required={false}>
                                <Select
                                  showSearch
                                  optionFilterProp="children"
                                  value={this.state.tipo_producto}
                                  onChange={this.handleChangeTipoProducto}
                                  disabled={this.state.es_duplicar}
                                  notFoundContent={'No se ha encontrado registros'}
                                  id="tipo_producto"
                                  autofocus="true"
                                >
                                  {
                                    colegiado &&
                                    colegiado.productos_deuda_colegiado &&
                                    colegiado.productos_deuda_colegiado.length > 0 &&
                                    colegiado.productos_deuda_colegiado.map((item, index) => {
                                      return (
                                        <Option key={index} producto={item} value={`${item.PROD_DESCRIPCION} ${item.computed1 ? '-': ''} ${item.computed1}`}>
                                          {item.PROD_DESCRIPCION} {item.computed1 ? '-': ''} {item.computed1} {item.es_negocios ? '': ''}
                                        </Option>
                                      );
                                    })
                                  }
                                </Select>
                              </FormItem>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                              <div style={{ display: 'flex', justifyContent: 'end', gap: 8 }}>
                              <Button type='primary' shape="round" loading={this.state.cargando_detalle} style={{ background: 'green', border: 'green' }} onClick={this.handleActualizar}>Actualizar</Button>
                              <Button type='primary' shape="round" onClick={() => this.handleExportar('xls')}>
                                Exportar XLS
                              </Button>
                              </div>
                            </Col>
                            
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                              <Table
                                  style={{ marginTop: 12 }}
                                  columns={columns_pago}
                                  rowKey={(record) => record.key}
                                  dataSource={this.state.detalle_pagos_colegiado}
                                  pagination={false}
                                  size="small"
                                  loading={this.state.cargando_detalle}
                                  locale={{
                                    emptyText: 'No se ha encontrado registros',
                                  }}
                                />
                            </Col>
                          </Row>
                        </TabPane>
                        <TabPane tab="Estado de cuentas" key="4">
                          <Row>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                              <FormItem label="Producto" required={false}>
                                <Select
                                  showSearch
                                  optionFilterProp="children"
                                  value={this.state.tipo_producto}
                                  onChange={this.handleChangeTipoProducto}
                                  disabled={this.state.es_duplicar}
                                  notFoundContent={'No se ha encontrado registros'}
                                  id="tipo_producto"
                                  autofocus="true"
                                >
                                  {
                                    colegiado &&
                                    colegiado.productos_deuda_colegiado &&
                                    colegiado.productos_deuda_colegiado.length > 0 &&
                                    colegiado.productos_deuda_colegiado.map((item, index) => {
                                      return (
                                        <Option key={index} producto={item} value={`${item.PROD_DESCRIPCION} ${item.computed1 ? '-': ''} ${item.computed1}`}>
                                          {item.PROD_DESCRIPCION} {item.computed1 ? '-': ''} {item.computed1} {item.es_negocios ? '': ''}
                                        </Option>
                                      );
                                    })
                                  }
                                </Select>
                              </FormItem>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                              <div style={{ display: 'flex', justifyContent: 'end', gap: 8 }}>
                              <Button type='primary' shape="round" loading={this.state.cargando_detalle} style={{ background: 'green', border: 'green' }} onClick={this.handleActualizar}>Actualizar</Button>
                              {
                                this.state.producto_id &&
                                <Button type='primary' shape="round" style={{ background: 'green', border: 'green' }} onClick={() => this.handleExportarEstadoCuenta('xls')}>
                                  Exportar Excel
                                </Button>
                              }
                              {
                                 this.state.producto_id &&
                                <Button type='primary' shape="round" onClick={() => this.handleExportarEstadoCuenta('pdf')}>
                                  Exportar PDF
                                </Button>
                              }
                              </div>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                              <h2><b>Último Pago:</b></h2>
                              <Table
                                  style={{ marginTop: 12 }}
                                  rowKey={(record) => record.id}
                                  columns={columns_ultimo_pago}
                                  dataSource={[this.state.producto]}
                                  pagination={false}
                                  size="small"
                                  locale={{
                                    emptyText: 'No se ha encontrado registros',
                                  }}
                                />
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                              <Table
                                  style={{ marginTop: 12 }}
                                  columns={columns_estado_cuenta}
                                  rowKey={(record) => record.key}
                                  dataSource={this.state.estado_cuentas}
                                  pagination={false}
                                  size="small"
                                  loading={this.state.cargando_detalle}
                                  locale={{
                                    emptyText: 'No se ha encontrado registros',
                                  }}
                                />
                            </Col>
                          </Row>
                        </TabPane>
                        <TabPane tab="Historial de envío de correos" key="5">
                          <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                              <Table
                                  style={{ marginTop: 12 }}
                                  columns={columns_historial_envio_correos}
                                  rowKey={(record) => record.key}
                                  dataSource={this.state.historial_envio_correos}
                                  pagination={false}
                                  size="small"
                                  loading={this.state.cargando_historial_envio_correos}
                                  locale={{
                                    emptyText: 'No se ha encontrado registros',
                                  }}
                                />
                            </Col>
                          </Row>
                        </TabPane>
                      </Tabs>
                    </div>
                  </div>
                </div>
              </div>
            </>
          }
        </Spin>
        {
          this.state.open_modal_cuota_ordinaria ? (
          <CuotaOrdinariaFormularioModal
            visible={this.state.open_modal_cuota_ordinaria}
            guardando={this.state.guardando_cuota_ordinaria}
            cuota_ordinaria={this.state.cuota_ordinaria}
            onFormSubmit={this.handleCreateCuotaOrdinariaFormSubmit}
            onCancel={this.handleClickCloseModalCuotaOrdinaria}
            colegiado_id={ this.state.id }
            ref={this.setFormModal}
          />
          ) : (
            ''
          )
        }

        {
          this.state.open_modal_cuota_fondo ? (
          <CuotaFondoFormularioModal
            visible={this.state.open_modal_cuota_fondo}
            guardando={this.state.guardando_cuota_fondo}
            cuota_fondo={this.state.cuota_fondo}
            onFormSubmit={this.handleCreateCuotaFondoFormSubmit}
            onCancel={this.handleClickCloseModalCuotaFondo}
            colegiado_id={ this.state.id }
            ref={this.setFormModal}
          />
          ) : (
            ''
          )
        }
        {
          this.state.open_modal_fraccionar ? (
          <FraccionarFormularioModal
            visible={this.state.open_modal_fraccionar}
            guardando={this.state.guardando_fraccionar}
            fraccionar={this.state.fraccionar}
            onFormSubmit={this.handleCreateFraccionarFormSubmit}
            onCancel={this.handleClickCloseModalFraccionar}
            colegiado_id={ this.state.id }
            importe_total={importe_total}
            adelanto={adelanto}
            importe_total_fecha_ini={importe_total_fecha_ini}
            importe_total_fecha_fin={importe_total_fecha_fin}
            ref={this.setFormFraccionarModal}
          />
          ) : (
            ''
          )
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state && state.user ? state.user : {},
    configuracion: state && state.configuracion ? state.configuracion : {},
    permisos: state && state.user && state.user.permisos && state.user.permisos.length > 0 ? state.user.permisos : [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ShowPagoPendientes);
